import { Link } from 'react-router-dom';

export const makeColumnsCardAssociates = ({
  handleCardDependent,
  proposalsAssociates,
}) => {
  return [
    {
      name: 'Nome',
      width: '80%',
      selector: (row) => row.name,
    },
    {
      cell: (cell) => {
        return (
          <div className="actions-hidden">
            <Link
              to={'#'}
              className="link-success"
              onClick={() =>
                handleCardDependent(
                  cell.customer_hashid,
                  proposalsAssociates.data[0].id
                )
              }
            >
              Imprimir cartão{' '}
              <i className="ri-arrow-right-line align-middle"></i>
            </Link>
          </div>
        );
      },
    },
  ];
};
